import React from 'react';
import VoicePicker from '../VoicePicker';
import {COPY_STRINGS} from '../../constants/translatedCopy';
import read_a_story from '../../images/voice_picker_icons/read_a_story.svg';
import read_a_story_spanish from '../../images/voice_picker_icons/read_a_story_spanish.svg';
import see_progress from '../../images/voice_picker_icons/see_progress.svg';
import take_a_test from '../../images/voice_picker_icons/take_a_test.svg';
import {logSessionInfo} from '../../services/logger';
import {endUserSession, getUserData} from '../../services/API';
import { amiraGestures } from '../../components/Coach/GesturedSpeech'
import {supportsSpeechRec} from "../../services/environment";
import {ErrorModal, getErrorModalTypes} from '../Reader/ErrorModal';
import device from '../../services/device/device';
import { openBadgeNotifications } from '../../components/Badging/badgingHomeHelpers';
import { GetBrandedAppName } from '../../services/BrandingService';

class ActivityPicker extends React.Component {
  //TODO: reduce code duplication with story picker
  constructor (props){
    super(props);
    this.state = {
      buttonsDisabled: true,
    };

    /*** initialize button options **/
    this.options = [];

    this.title = COPY_STRINGS.great_to_see_you + ",";
    this.subTitle = COPY_STRINGS.what_activity_today;
    this.prompt = COPY_STRINGS.didnt_understand + " " + COPY_STRINGS.what_activity_next;

    this.selectOption = this.selectOption.bind(this);
    if(this.props.demoMode){
      this.options.push({name: COPY_STRINGS.take_a_test, route: "/student/assessment", image: take_a_test, voiceDescription: COPY_STRINGS.take_a_test_speech});
    }
    if(this.props.tutorEnabled){
      const tutorOption = {
        route: "/student/tutor",
        locale: "en-us",
      };
      this.options.push({...tutorOption, name: COPY_STRINGS.read_a_story, image: read_a_story, voiceDescription: COPY_STRINGS.read_a_story_speech});

      if(getUserData().isESL){
        this.options.push({...tutorOption, locale: 'es-mx', name: COPY_STRINGS.read_a_story_in_spanish, image: read_a_story_spanish, voiceDescription: COPY_STRINGS.read_a_story_in_spanish_speech});
      }
      //###Keep this out for now: this.options.push({name: "Read me a story", route: "/student/readAloud", image: read_me_a_story, voiceDescription: " should I reed a story to you "});
    }

    //For now, don't show the progress option for early readers because the new progress report showing early reader activities hasn't been developed yet.
    //TODO: show progress option when early reader progress report is ready.
    if(!getUserData().isEarlyReader){
      this.options.push({name: COPY_STRINGS.see_progress, route: "/student/reports/progress/" + this.props.studentId, image: see_progress, voiceDescription: COPY_STRINGS.see_progress_speech});
    }
  }

  componentDidMount(){
    window.setTimeout(this.sayPrompt.bind(this),100);
  }

  sayPrompt(){
    let props = {
      textToSpeak: "",
    };

    props.onStart= (
      function(event){
        this.setState({
          buttonsDisabled: false,
        });
      }
    ).bind(this);

    if(!this.options.length){
      props.textToSpeak = COPY_STRINGS.no_activities_speech;
    }else{
      props.textToSpeak = COPY_STRINGS.would_you_like + " ";
      for(let i=0; i<this.options.length; i++){
        props.textToSpeak += this.options[i].voiceDescription;
        props.textToSpeak += ", "
        if(i === this.options.length-2){
          props.textToSpeak += COPY_STRINGS.or + " ";
        }
      }
      props.textToSpeak += "?";
      props.skipAvatar = false;
    }
    //Send the proper sentence to the TTS object
    this.props.speech.speak(props, false);
  }

  // returns a function to select a given story
  selectOption(option){
    if(this.props.speech){
      this.props.speech.abortSpeech();
    }

    if(option.locale) {
      this.props.setLocale(option.locale);
    }
    this.props.close();
    this.props.history.push(option.route);
  }

  render() {
    return (
      <VoicePicker
        options={this.options}
        highlightedText={`${this.props.studentName}!`}
        speech={this.props.speech}
        title={this.title}
        subTitle={this.subTitle}
        prompt={this.prompt}
        selectOption={this.selectOption}
        buttonsDisabled={this.state.buttonsDisabled}
      />
    );
  }
}


export default class StudentHome extends React.Component {
  constructor (props){
    super(props);
  }

  componentDidMount(){
    document.title = `Student Main Menu - ${GetBrandedAppName()}`;

    //reset locale to en-us when the user returns to student home,
    //unless they've changed the language setting
    if(!getUserData().bilingualMode) {
      this.props.setLocale('en-us');
    }

    this.props.resetStory();

    const popStateOrigin = this.props.history.location.state ? this.props.history.location.state.popStateOrigin : null;
    if(popStateOrigin && this.props.history.action === "REPLACE"){
      logSessionInfo("popstate", { location: this.props.location, history: this.props.history});
      this.props.history.push(popStateOrigin);
    }else if(this.props.speech){
      this.props.history.push(this.props.location.pathname);
      this.showDialogs();
    }
  }

  componentDidUpdate(oldProps){
    const popStateOrigin = this.props.history.location.state ? this.props.history.location.state.popStateOrigin : null;
    if(!popStateOrigin && this.props.history.action === "POP" && this.props.history.location.pathname === this.props.location.pathname){
      console.log("SKIPPING END SESSION")
      //Temporarily disable ending the user session on the home screen
      //###endUserSession();
    }

    if(this.props.speech && !oldProps.speech){
      this.showDialogs()
    }
  }

  async showDialogs(){
    const { userId } = getUserData();
    if(getUserData().badgingEnabled){
      await openBadgeNotifications({
        userId,
        openModal: this.props.openModal,
        speech: this.props.speech
      });
      this.props.speech.playDance({gesture: amiraGestures.Idle} );
    }
    this.open();
  }

  open(){
    this.props.openModal(
      <ActivityPicker
        close={this.props.closeModal}
        sendMessage={this.props.sendMessage}
        studentName={this.props.studentName}
        studentId={this.props.studentId}
        history={this.props.history}
        speech={this.props.speech}
        resetTranscript={this.props.speech && this.props.speech.resetTranscript}
        tutorEnabled={this.props.session.tutorEnabled}
        assessmentEnabled={this.props.session.assessmentEnabled}
        demoMode={this.props.session.demoMode}
        setLocale={this.props.setLocale}
        openModal={this.props.openModal}
        openParent={this.open.bind(this)}
      />,
      {backgroundClose: false, key: "studentHome"}
    );
  }

  render(){
    return <div />;
  }
}
